import { Union, Record } from "../../fable_modules/fable-library-js.4.28.0/Types.js";
import { float64_type, class_type, tuple_type, list_type, union_type, record_type, bool_type, int32_type, option_type, string_type } from "../../fable_modules/fable-library-js.4.28.0/Reflection.js";
import { ArrangementFeedback_$reflection, PublicLink_$reflection, RsvpGuestLink_$reflection, RsvpSummary_$reflection, RsvpConfig_$reflection, Tag_$reflection, ApiError_$reflection, ArrangeResponse_$reflection, ConstraintKey_$reflection, GroupMember_$reflection, GuestGroup_$reflection, FamilyMember_$reflection, Family_$reflection, GuestPair_$reflection, Arrangement_$reflection, SeatingRule_$reflection, Table_$reflection, Guest_$reflection, CulturePreset, SoftConstraintWeights_defaultWeights, SoftConstraintWeights_presetWeights, SoftConstraintWeights_allConstraints, SeatAssignment_$reflection, RuleType, RuleTypeModule_toInt, SeatingStyle, SeatingStyleModule_toInt, TableShape, TableShapeModule_toInt, PairType, PairTypeModule_toInt, Event$_$reflection, AttendanceStatus, AttendanceStatusModule_toInt, AgeCategory, AgeCategoryModule_toInt, Gender, GenderModule_toInt } from "../../Shared/Types.js";
import { map, defaultArg } from "../../fable_modules/fable-library-js.4.28.0/Option.js";
import { comparePrimitives, int32ToString } from "../../fable_modules/fable-library-js.4.28.0/Util.js";
import { ofArray, tryFind, tail, head, isEmpty, cons, empty } from "../../fable_modules/fable-library-js.4.28.0/List.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.28.0/Result.js";
import { split, trim, join, trimStart, trimEnd } from "../../fable_modules/fable-library-js.4.28.0/String.js";
import { map as map_1 } from "../../fable_modules/fable-library-js.4.28.0/Array.js";
import { empty as empty_1 } from "../../fable_modules/fable-library-js.4.28.0/Set.js";
import { empty as empty_2 } from "../../fable_modules/fable-library-js.4.28.0/Map.js";

export class GuestEditForm extends Record {
    constructor(Id, FirstName, LastName, Gender, AgeCategory, AttendanceStatus, Title, Rank, DietaryNotes, DietaryTags, Wheelchair, Tags, Notes, Version, IsSubmitting, ValidationAttempt, Error$, FullNameInput) {
        super();
        this.Id = Id;
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Gender = (Gender | 0);
        this.AgeCategory = (AgeCategory | 0);
        this.AttendanceStatus = (AttendanceStatus | 0);
        this.Title = Title;
        this.Rank = Rank;
        this.DietaryNotes = DietaryNotes;
        this.DietaryTags = DietaryTags;
        this.Wheelchair = Wheelchair;
        this.Tags = Tags;
        this.Notes = Notes;
        this.Version = (Version | 0);
        this.IsSubmitting = IsSubmitting;
        this.ValidationAttempt = (ValidationAttempt | 0);
        this.Error = Error$;
        this.FullNameInput = FullNameInput;
    }
}

export function GuestEditForm_$reflection() {
    return record_type("Client.Pages.Event.State.GuestEditForm", [], GuestEditForm, () => [["Id", option_type(string_type)], ["FirstName", string_type], ["LastName", string_type], ["Gender", int32_type], ["AgeCategory", int32_type], ["AttendanceStatus", int32_type], ["Title", string_type], ["Rank", string_type], ["DietaryNotes", string_type], ["DietaryTags", string_type], ["Wheelchair", bool_type], ["Tags", string_type], ["Notes", string_type], ["Version", int32_type], ["IsSubmitting", bool_type], ["ValidationAttempt", int32_type], ["Error", option_type(string_type)], ["FullNameInput", string_type]]);
}

export const GuestEditFormModule_empty = new GuestEditForm(undefined, "", "", GenderModule_toInt(new Gender(3, [])), AgeCategoryModule_toInt(new AgeCategory(2, [])), AttendanceStatusModule_toInt(new AttendanceStatus(0, [])), "", "", "", "", false, "", "", 0, false, 0, undefined, "");

export function GuestEditFormModule_fromGuest(g) {
    return new GuestEditForm(g.Id, g.FirstName, g.LastName, g.Gender, g.AgeCategory, g.AttendanceStatus, defaultArg(g.Title, ""), defaultArg(map(int32ToString, g.Rank), ""), defaultArg(g.DietaryNotes, ""), defaultArg(g.DietaryTags, ""), g.Wheelchair, defaultArg(g.Tags, ""), defaultArg(g.Notes, ""), g.Version, false, 0, undefined, "");
}

export function GuestEditFormModule_isValid(form) {
    if (form.FirstName.trim() !== "") {
        return form.LastName.trim() !== "";
    }
    else {
        return false;
    }
}

export class ImportStep extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Upload", "MapColumns", "Preview"];
    }
}

export function ImportStep_$reflection() {
    return union_type("Client.Pages.Event.State.ImportStep", [], ImportStep, () => [[], [], []]);
}

export class ColumnMapping extends Record {
    constructor(FirstName, LastName, Gender, AgeCategory, Title, DietaryNotes, DietaryTags, Tags, Notes) {
        super();
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Gender = Gender;
        this.AgeCategory = AgeCategory;
        this.Title = Title;
        this.DietaryNotes = DietaryNotes;
        this.DietaryTags = DietaryTags;
        this.Tags = Tags;
        this.Notes = Notes;
    }
}

export function ColumnMapping_$reflection() {
    return record_type("Client.Pages.Event.State.ColumnMapping", [], ColumnMapping, () => [["FirstName", option_type(int32_type)], ["LastName", option_type(int32_type)], ["Gender", option_type(int32_type)], ["AgeCategory", option_type(int32_type)], ["Title", option_type(int32_type)], ["DietaryNotes", option_type(int32_type)], ["DietaryTags", option_type(int32_type)], ["Tags", list_type(int32_type)], ["Notes", option_type(int32_type)]]);
}

export const ColumnMappingModule_empty = new ColumnMapping(undefined, undefined, undefined, undefined, undefined, undefined, undefined, empty(), undefined);

export class ParsedGuest extends Record {
    constructor(FirstName, LastName, Title, Gender, Tags, Notes) {
        super();
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Title = Title;
        this.Gender = Gender;
        this.Tags = Tags;
        this.Notes = Notes;
    }
}

export function ParsedGuest_$reflection() {
    return record_type("Client.Pages.Event.State.ParsedGuest", [], ParsedGuest, () => [["FirstName", string_type], ["LastName", string_type], ["Title", string_type], ["Gender", option_type(int32_type)], ["Tags", string_type], ["Notes", string_type]]);
}

export class ImportState extends Record {
    constructor(Step, CsvContent, Headers, Rows, Mapping, IsImporting, Error$, PasteText, ParsedGuests, NamesSwapped, BulkImportTags, CloneEvents, CloneSourceEventId, CloneIncludeRelationships) {
        super();
        this.Step = Step;
        this.CsvContent = CsvContent;
        this.Headers = Headers;
        this.Rows = Rows;
        this.Mapping = Mapping;
        this.IsImporting = IsImporting;
        this.Error = Error$;
        this.PasteText = PasteText;
        this.ParsedGuests = ParsedGuests;
        this.NamesSwapped = NamesSwapped;
        this.BulkImportTags = BulkImportTags;
        this.CloneEvents = CloneEvents;
        this.CloneSourceEventId = CloneSourceEventId;
        this.CloneIncludeRelationships = CloneIncludeRelationships;
    }
}

export function ImportState_$reflection() {
    return record_type("Client.Pages.Event.State.ImportState", [], ImportState, () => [["Step", ImportStep_$reflection()], ["CsvContent", string_type], ["Headers", list_type(string_type)], ["Rows", list_type(list_type(string_type))], ["Mapping", ColumnMapping_$reflection()], ["IsImporting", bool_type], ["Error", option_type(string_type)], ["PasteText", string_type], ["ParsedGuests", list_type(ParsedGuest_$reflection())], ["NamesSwapped", bool_type], ["BulkImportTags", string_type], ["CloneEvents", list_type(Event$_$reflection())], ["CloneSourceEventId", string_type], ["CloneIncludeRelationships", bool_type]]);
}

export const ImportStateModule_empty = new ImportState(new ImportStep(0, []), "", empty(), empty(), ColumnMappingModule_empty, false, undefined, "", empty(), false, "", empty(), "", true);

export class PairForm extends Record {
    constructor(Guest1Id, Guest2Id, PairType) {
        super();
        this.Guest1Id = Guest1Id;
        this.Guest2Id = Guest2Id;
        this.PairType = (PairType | 0);
    }
}

export function PairForm_$reflection() {
    return record_type("Client.Pages.Event.State.PairForm", [], PairForm, () => [["Guest1Id", string_type], ["Guest2Id", string_type], ["PairType", int32_type]]);
}

export const PairFormModule_empty = new PairForm("", "", PairTypeModule_toInt(new PairType(0, [])));

export class FamilyForm extends Record {
    constructor(Name, MemberIds) {
        super();
        this.Name = Name;
        this.MemberIds = MemberIds;
    }
}

export function FamilyForm_$reflection() {
    return record_type("Client.Pages.Event.State.FamilyForm", [], FamilyForm, () => [["Name", string_type], ["MemberIds", list_type(string_type)]]);
}

export const FamilyFormModule_empty = new FamilyForm("", empty());

export class GroupForm extends Record {
    constructor(Name, GroupType, MemberIds) {
        super();
        this.Name = Name;
        this.GroupType = GroupType;
        this.MemberIds = MemberIds;
    }
}

export function GroupForm_$reflection() {
    return record_type("Client.Pages.Event.State.GroupForm", [], GroupForm, () => [["Name", string_type], ["GroupType", string_type], ["MemberIds", list_type(string_type)]]);
}

export const GroupFormModule_empty = new GroupForm("", "", empty());

export class GuestSortColumn extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SortByName", "SortByGender", "SortByAge", "SortByStatus", "SortByFamily", "SortByTags"];
    }
}

export function GuestSortColumn_$reflection() {
    return union_type("Client.Pages.Event.State.GuestSortColumn", [], GuestSortColumn, () => [[], [], [], [], [], []]);
}

export class SortDirection extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Ascending", "Descending"];
    }
}

export function SortDirection_$reflection() {
    return union_type("Client.Pages.Event.State.SortDirection", [], SortDirection, () => [[], []]);
}

export class TableEditForm extends Record {
    constructor(Id, Name, Shape, Capacity, SeatsLongSide, SeatsShortEnd, SeatingStyle, IsHonorTable, SortOrder, Version, Count, IsSubmitting, Error$) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Shape = (Shape | 0);
        this.Capacity = (Capacity | 0);
        this.SeatsLongSide = (SeatsLongSide | 0);
        this.SeatsShortEnd = (SeatsShortEnd | 0);
        this.SeatingStyle = (SeatingStyle | 0);
        this.IsHonorTable = IsHonorTable;
        this.SortOrder = (SortOrder | 0);
        this.Version = (Version | 0);
        this.Count = (Count | 0);
        this.IsSubmitting = IsSubmitting;
        this.Error = Error$;
    }
}

export function TableEditForm_$reflection() {
    return record_type("Client.Pages.Event.State.TableEditForm", [], TableEditForm, () => [["Id", option_type(string_type)], ["Name", string_type], ["Shape", int32_type], ["Capacity", int32_type], ["SeatsLongSide", int32_type], ["SeatsShortEnd", int32_type], ["SeatingStyle", int32_type], ["IsHonorTable", bool_type], ["SortOrder", int32_type], ["Version", int32_type], ["Count", int32_type], ["IsSubmitting", bool_type], ["Error", option_type(string_type)]]);
}

export const TableEditFormModule_empty = new TableEditForm(undefined, "", TableShapeModule_toInt(new TableShape(0, [])), 8, 4, 0, SeatingStyleModule_toInt(new SeatingStyle(0, [])), false, 0, 0, 1, false, undefined);

export function TableEditFormModule_fromTable(t) {
    return new TableEditForm(t.Id, t.Name, t.Shape, t.Capacity, t.SeatsLongSide, t.SeatsShortEnd, t.SeatingStyle, t.IsHonorTable, t.SortOrder, t.Version, 1, false, undefined);
}

export class RuleForm extends Record {
    constructor(RuleType, SubjectId, ObjectId, Parameter, IsHard, Description, IsSubmitting, Error$) {
        super();
        this.RuleType = (RuleType | 0);
        this.SubjectId = SubjectId;
        this.ObjectId = ObjectId;
        this.Parameter = Parameter;
        this.IsHard = IsHard;
        this.Description = Description;
        this.IsSubmitting = IsSubmitting;
        this.Error = Error$;
    }
}

export function RuleForm_$reflection() {
    return record_type("Client.Pages.Event.State.RuleForm", [], RuleForm, () => [["RuleType", int32_type], ["SubjectId", string_type], ["ObjectId", string_type], ["Parameter", string_type], ["IsHard", bool_type], ["Description", string_type], ["IsSubmitting", bool_type], ["Error", option_type(string_type)]]);
}

export const RuleFormModule_empty = new RuleForm(RuleTypeModule_toInt(new RuleType(0, [])), "", "", "", false, "", false, undefined);

export class GuestViewMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TableView", "CardView", "NetworkMapView"];
    }
}

export function GuestViewMode_$reflection() {
    return union_type("Client.Pages.Event.State.GuestViewMode", [], GuestViewMode, () => [[], [], []]);
}

export class ArrangementViewMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Overview", "ListView"];
    }
}

export function ArrangementViewMode_$reflection() {
    return union_type("Client.Pages.Event.State.ArrangementViewMode", [], ArrangementViewMode, () => [[], []]);
}

export class EditHistory extends Record {
    constructor(Past, Future) {
        super();
        this.Past = Past;
        this.Future = Future;
    }
}

export function EditHistory_$reflection() {
    return record_type("Client.Pages.Event.State.EditHistory", [], EditHistory, () => [["Past", list_type(list_type(SeatAssignment_$reflection()))], ["Future", list_type(list_type(SeatAssignment_$reflection()))]]);
}

export const EditHistoryModule_empty = new EditHistory(empty(), empty());

export function EditHistoryModule_push(current, history) {
    return new EditHistory(cons(current, history.Past), empty());
}

export function EditHistoryModule_canUndo(history) {
    return !isEmpty(history.Past);
}

export function EditHistoryModule_canRedo(history) {
    return !isEmpty(history.Future);
}

export function EditHistoryModule_undo(current, history) {
    const matchValue = history.Past;
    if (isEmpty(matchValue)) {
        return [undefined, history];
    }
    else {
        return [head(matchValue), new EditHistory(tail(matchValue), cons(current, history.Future))];
    }
}

export function EditHistoryModule_redo(current, history) {
    const matchValue = history.Future;
    if (isEmpty(matchValue)) {
        return [undefined, history];
    }
    else {
        return [head(matchValue), new EditHistory(cons(current, history.Past), tail(matchValue))];
    }
}

export const ConstraintWeights_allConstraints = SoftConstraintWeights_allConstraints;

export function ConstraintWeights_presetWeights(preset) {
    return SoftConstraintWeights_presetWeights(preset);
}

export const ConstraintWeights_defaultWeights = SoftConstraintWeights_defaultWeights;

/**
 * Detect which culture preset matches the given weights, if any.
 * Returns CustomCulture if no named preset matches.
 */
export function ConstraintWeights_detectPreset(weights) {
    return defaultArg(tryFind((p) => ConstraintWeights_presetWeights(p).Equals(weights), ofArray([new CulturePreset(0, []), new CulturePreset(1, []), new CulturePreset(2, []), new CulturePreset(3, []), new CulturePreset(4, []), new CulturePreset(5, [])])), new CulturePreset(6, []));
}

export class EventState extends Record {
    constructor(Event$, Guests, Tables, Rules, Arrangements, Pairs, Families, Groups, SelectedGuestId, GuestEditForm, ShowImportWizard, ImportState, GuestSearch, GuestSortColumn, GuestSortDirection, GuestStatusFilter, GuestViewMode, PairForm, FamilyForm, GroupForm, TableEditForm, RuleForm, ShowAdvancedRules, ConstraintWeights, ShowDeleteConfirm, IsLoading, Error$, IsArranging, ArrangeStatus, ArrangeStep, ArrangeSteps, ArrangeStepIntervals, PendingArrangeResult, ArrangeTimeoutSeconds, EmptySeatStrategy, SelectedArrangementId, ArrangementAssignments, SelectedDetailGuestId, SelectedDetailTableIndex, IsEditMode, EditSwapFirst, LockedGuestIds, EditHistory, OriginalAssignments, ShowArrangementPreview, ArrangementViewMode, IsDraggingTable, DragOffset, GridSnap, SelectedFloorPlanTable, QuickAddInput, QuickAddFlash, QuickAddPlusN, QuickAddHostGuest, IsListening, InlineEditCell, InlineEditValue, TagRenameEditing, TagRenameValue, TagMergeSelection, TagManagementError, Tags, TagGroupStrategies, ExportTheme, ExportLayout, RsvpConfig, RsvpSummary, RsvpGuestLinks, RsvpConfigForm, PublicLinks, PublicLinksLoading, ArrangementFeedback) {
        super();
        this.Event = Event$;
        this.Guests = Guests;
        this.Tables = Tables;
        this.Rules = Rules;
        this.Arrangements = Arrangements;
        this.Pairs = Pairs;
        this.Families = Families;
        this.Groups = Groups;
        this.SelectedGuestId = SelectedGuestId;
        this.GuestEditForm = GuestEditForm;
        this.ShowImportWizard = ShowImportWizard;
        this.ImportState = ImportState;
        this.GuestSearch = GuestSearch;
        this.GuestSortColumn = GuestSortColumn;
        this.GuestSortDirection = GuestSortDirection;
        this.GuestStatusFilter = GuestStatusFilter;
        this.GuestViewMode = GuestViewMode;
        this.PairForm = PairForm;
        this.FamilyForm = FamilyForm;
        this.GroupForm = GroupForm;
        this.TableEditForm = TableEditForm;
        this.RuleForm = RuleForm;
        this.ShowAdvancedRules = ShowAdvancedRules;
        this.ConstraintWeights = ConstraintWeights;
        this.ShowDeleteConfirm = ShowDeleteConfirm;
        this.IsLoading = IsLoading;
        this.Error = Error$;
        this.IsArranging = IsArranging;
        this.ArrangeStatus = ArrangeStatus;
        this.ArrangeStep = (ArrangeStep | 0);
        this.ArrangeSteps = ArrangeSteps;
        this.ArrangeStepIntervals = ArrangeStepIntervals;
        this.PendingArrangeResult = PendingArrangeResult;
        this.ArrangeTimeoutSeconds = (ArrangeTimeoutSeconds | 0);
        this.EmptySeatStrategy = (EmptySeatStrategy | 0);
        this.SelectedArrangementId = SelectedArrangementId;
        this.ArrangementAssignments = ArrangementAssignments;
        this.SelectedDetailGuestId = SelectedDetailGuestId;
        this.SelectedDetailTableIndex = SelectedDetailTableIndex;
        this.IsEditMode = IsEditMode;
        this.EditSwapFirst = EditSwapFirst;
        this.LockedGuestIds = LockedGuestIds;
        this.EditHistory = EditHistory;
        this.OriginalAssignments = OriginalAssignments;
        this.ShowArrangementPreview = ShowArrangementPreview;
        this.ArrangementViewMode = ArrangementViewMode;
        this.IsDraggingTable = IsDraggingTable;
        this.DragOffset = DragOffset;
        this.GridSnap = GridSnap;
        this.SelectedFloorPlanTable = SelectedFloorPlanTable;
        this.QuickAddInput = QuickAddInput;
        this.QuickAddFlash = QuickAddFlash;
        this.QuickAddPlusN = (QuickAddPlusN | 0);
        this.QuickAddHostGuest = QuickAddHostGuest;
        this.IsListening = IsListening;
        this.InlineEditCell = InlineEditCell;
        this.InlineEditValue = InlineEditValue;
        this.TagRenameEditing = TagRenameEditing;
        this.TagRenameValue = TagRenameValue;
        this.TagMergeSelection = TagMergeSelection;
        this.TagManagementError = TagManagementError;
        this.Tags = Tags;
        this.TagGroupStrategies = TagGroupStrategies;
        this.ExportTheme = (ExportTheme | 0);
        this.ExportLayout = (ExportLayout | 0);
        this.RsvpConfig = RsvpConfig;
        this.RsvpSummary = RsvpSummary;
        this.RsvpGuestLinks = RsvpGuestLinks;
        this.RsvpConfigForm = RsvpConfigForm;
        this.PublicLinks = PublicLinks;
        this.PublicLinksLoading = PublicLinksLoading;
        this.ArrangementFeedback = ArrangementFeedback;
    }
}

export function EventState_$reflection() {
    return record_type("Client.Pages.Event.State.EventState", [], EventState, () => [["Event", option_type(Event$_$reflection())], ["Guests", list_type(Guest_$reflection())], ["Tables", list_type(Table_$reflection())], ["Rules", list_type(SeatingRule_$reflection())], ["Arrangements", list_type(Arrangement_$reflection())], ["Pairs", list_type(GuestPair_$reflection())], ["Families", list_type(tuple_type(Family_$reflection(), list_type(FamilyMember_$reflection())))], ["Groups", list_type(tuple_type(GuestGroup_$reflection(), list_type(GroupMember_$reflection())))], ["SelectedGuestId", option_type(string_type)], ["GuestEditForm", option_type(GuestEditForm_$reflection())], ["ShowImportWizard", bool_type], ["ImportState", ImportState_$reflection()], ["GuestSearch", string_type], ["GuestSortColumn", GuestSortColumn_$reflection()], ["GuestSortDirection", SortDirection_$reflection()], ["GuestStatusFilter", option_type(int32_type)], ["GuestViewMode", GuestViewMode_$reflection()], ["PairForm", PairForm_$reflection()], ["FamilyForm", FamilyForm_$reflection()], ["GroupForm", GroupForm_$reflection()], ["TableEditForm", option_type(TableEditForm_$reflection())], ["RuleForm", option_type(RuleForm_$reflection())], ["ShowAdvancedRules", bool_type], ["ConstraintWeights", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [ConstraintKey_$reflection(), int32_type])], ["ShowDeleteConfirm", option_type(string_type)], ["IsLoading", bool_type], ["Error", option_type(string_type)], ["IsArranging", bool_type], ["ArrangeStatus", option_type(string_type)], ["ArrangeStep", int32_type], ["ArrangeSteps", list_type(string_type)], ["ArrangeStepIntervals", list_type(int32_type)], ["PendingArrangeResult", option_type(union_type("Microsoft.FSharp.Core.FSharpResult`2", [ArrangeResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", ArrangeResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]]))], ["ArrangeTimeoutSeconds", int32_type], ["EmptySeatStrategy", int32_type], ["SelectedArrangementId", option_type(string_type)], ["ArrangementAssignments", list_type(SeatAssignment_$reflection())], ["SelectedDetailGuestId", option_type(string_type)], ["SelectedDetailTableIndex", option_type(int32_type)], ["IsEditMode", bool_type], ["EditSwapFirst", option_type(string_type)], ["LockedGuestIds", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])], ["EditHistory", EditHistory_$reflection()], ["OriginalAssignments", list_type(SeatAssignment_$reflection())], ["ShowArrangementPreview", bool_type], ["ArrangementViewMode", ArrangementViewMode_$reflection()], ["IsDraggingTable", option_type(string_type)], ["DragOffset", tuple_type(float64_type, float64_type)], ["GridSnap", bool_type], ["SelectedFloorPlanTable", option_type(string_type)], ["QuickAddInput", string_type], ["QuickAddFlash", option_type(string_type)], ["QuickAddPlusN", int32_type], ["QuickAddHostGuest", option_type(Guest_$reflection())], ["IsListening", bool_type], ["InlineEditCell", option_type(tuple_type(string_type, string_type))], ["InlineEditValue", string_type], ["TagRenameEditing", option_type(string_type)], ["TagRenameValue", string_type], ["TagMergeSelection", list_type(string_type)], ["TagManagementError", option_type(string_type)], ["Tags", list_type(Tag_$reflection())], ["TagGroupStrategies", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, int32_type])], ["ExportTheme", int32_type], ["ExportLayout", int32_type], ["RsvpConfig", option_type(RsvpConfig_$reflection())], ["RsvpSummary", option_type(RsvpSummary_$reflection())], ["RsvpGuestLinks", list_type(RsvpGuestLink_$reflection())], ["RsvpConfigForm", option_type(RsvpConfigForm_$reflection())], ["PublicLinks", list_type(PublicLink_$reflection())], ["PublicLinksLoading", bool_type], ["ArrangementFeedback", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, list_type(ArrangementFeedback_$reflection())])]]);
}

export class RsvpConfigForm extends Record {
    constructor(IsOpen, Deadline, AllowPlusOne, MealOptions, ConfirmationMessage, IsSubmitting, Error$) {
        super();
        this.IsOpen = IsOpen;
        this.Deadline = Deadline;
        this.AllowPlusOne = AllowPlusOne;
        this.MealOptions = MealOptions;
        this.ConfirmationMessage = ConfirmationMessage;
        this.IsSubmitting = IsSubmitting;
        this.Error = Error$;
    }
}

export function RsvpConfigForm_$reflection() {
    return record_type("Client.Pages.Event.State.RsvpConfigForm", [], RsvpConfigForm, () => [["IsOpen", bool_type], ["Deadline", string_type], ["AllowPlusOne", bool_type], ["MealOptions", string_type], ["ConfirmationMessage", string_type], ["IsSubmitting", bool_type], ["Error", option_type(string_type)]]);
}

export const RsvpConfigFormModule_empty = new RsvpConfigForm(true, "", false, "", "", false, undefined);

export function RsvpConfigFormModule_fromConfig(c) {
    let matchValue, json, trimmed, array_1;
    return new RsvpConfigForm(c.IsOpen, defaultArg(c.Deadline, ""), c.AllowPlusOne, (matchValue = c.MealOptions, (matchValue == null) ? "" : ((json = matchValue, (trimmed = trimEnd(trimStart(json.trim(), "["), "]"), (trimmed.trim() === "") ? "" : join(", ", (array_1 = map_1((s) => trim(s.trim(), "\""), split(trimmed, [","], undefined, 0)), array_1.filter((s_1) => (s_1 !== "")))))))), defaultArg(c.ConfirmationMessage, ""), false, undefined);
}

export function init() {
    return new EventState(undefined, empty(), empty(), empty(), empty(), empty(), empty(), empty(), undefined, undefined, false, ImportStateModule_empty, "", new GuestSortColumn(0, []), new SortDirection(0, []), undefined, new GuestViewMode(0, []), PairFormModule_empty, FamilyFormModule_empty, GroupFormModule_empty, undefined, undefined, false, ConstraintWeights_defaultWeights, undefined, false, undefined, false, undefined, 0, empty(), empty(), undefined, 60, 0, undefined, empty(), undefined, undefined, false, undefined, empty_1({
        Compare: comparePrimitives,
    }), EditHistoryModule_empty, empty(), true, new ArrangementViewMode(0, []), undefined, [0, 0], false, undefined, "", undefined, 0, undefined, false, undefined, "", undefined, "", empty(), undefined, empty(), empty_2({
        Compare: comparePrimitives,
    }), 0, 0, undefined, undefined, empty(), undefined, empty(), false, empty_2({
        Compare: comparePrimitives,
    }));
}

